import React from "react";
import { useFormContext } from "react-hook-form";
import RadioCss from "./radioBtn.module.scss";



function Radiobutton(props) {
  const { text, inputId, name,value } = props;
  const { register } = useFormContext();

  return (
    <>
      <label className={`${RadioCss.tabclix__label_radio}`}>
        <input
          {...register(`${name}`)}
          className={`${RadioCss.tabclix__radio}`}
          type="radio"
          value={value}
          id={inputId}
          name={name}
        />
        <span className="w-form-label" htmlFor="radio">
          {text}
        </span>
      </label>
    </>
  );
}

export default Radiobutton;

// VERSION 1.0
// import React from 'react'

// function Radiobutton(props) {
//   return (
//     <>
//     <label class="w-radio radio-field">
//         <input type="radio" id={props.inputId} name={props.inputName} />
//        <svg
//           className={'radiobutton'}
//           // This element is purely decorative so
//           // we hide it for screen readers
//           aria-hidden="true"
//           viewBox="0 0 0 11"
//           fill="none"
//         ></svg>
//         <div class="w-radio-input w-radio-input--inputType-custom radio"></div>
//             <span class="w-form-label" for="radio">Radio button</span>
//             </label>
//     </>
//   )
// }

// export default Radiobutton
